// // // import React, { useEffect, useState, useRef } from "react";
// // // import { collection, query, getDocs, updateDoc, doc } from "firebase/firestore";
// // // import { db } from "../../firebase";
// // // import css from "./adm.module.css";

// // // // const OrderList = () => {
// // // //     const [orders, setOrders] = useState([]);
// // // //     const [selectedOrder, setSelectedOrder] = useState(null);
// // // //     const [editingStatusId, setEditingStatusId] = useState(null);
// // // //     const statusInputRef = useRef(null);

// // // //     useEffect(() => {
// // // //       const fetchOrders = async () => {
// // // //         const ordersRef = collection(db, 'orders');
// // // //         const querySnapshot = await getDocs(ordersRef);

// // // //         const parsedData = [];
// // // //         querySnapshot.forEach((doc) => {
// // // //           const order = { id: doc.id, ...doc.data() };
// // // //           const choice = JSON.parse(order.choice);
// // // //           parsedData.push({ order, choice });
// // // //         });

// // // //         setOrders(parsedData);
// // // //       };

// // // //       fetchOrders();
// // // //     }, []);

// // // //     const handleStatusDoubleClick = (orderId) => {
// // // //       setEditingStatusId(orderId);
// // // //     };

// // // //     const handleStatusChange = async (orderId, newStatus) => {
// // // //       const orderDocRef = doc(db, 'orders', orderId);
// // // //       await updateDoc(orderDocRef, { status: newStatus });

// // // //       setOrders((prevOrders) =>
// // // //         prevOrders.map((order) => {
// // // //           if (order.order.id === orderId) {
// // // //             return { ...order, order: { ...order.order, status: newStatus } };
// // // //           }
// // // //           return order;
// // // //         })
// // // //       );
// // // //     };

// // // //     const handleStatusBlur = () => {
// // // //       setEditingStatusId(null);
// // // //     };

// // // //     const handleOrderClick = (order) => {
// // // //       setSelectedOrder(order);
// // // //     };

// // // //     useEffect(() => {
// // // //       if (editingStatusId === selectedOrder?.order.id && statusInputRef.current) {
// // // //         statusInputRef.current.focus();
// // // //       }
// // // //     }, [editingStatusId, selectedOrder]);

// // // //     return (
// // // //       <div>
// // // //         {orders.map((orderItem) => (
// // // //           <div key={orderItem.order.id} onClick={() => handleOrderClick(orderItem)}>
// // // //             <p>{orderItem.order.uid}</p>
// // // //             {editingStatusId === orderItem.order.id ? (
// // // //               <input
// // // //                 type="text"
// // // //                 value={orderItem.order.status}
// // // //                 onChange={(e) => handleStatusChange(orderItem.order.id, e.target.value)}
// // // //                 onBlur={handleStatusBlur}
// // // //                 ref={statusInputRef}
// // // //               />
// // // //             ) : (
// // // //               <p onDoubleClick={() => handleStatusDoubleClick(orderItem.order.id)}>{orderItem.order.status}</p>
// // // //             )}
// // // //             {selectedOrder === orderItem && (
// // // //               <div>
// // // //                 {orderItem.choice.map((tovar) => (
// // // //                   <div key={tovar.id}>
// // // //                     <p>{tovar.name}</p>
// // // //                     <p>{tovar.price}</p>
// // // //                   </div>
// // // //                 ))}
// // // //               </div>
// // // //             )}
// // // //           </div>
// // // //         ))}
// // // //       </div>
// // // //     );
// // // //   };

// // // //   export default OrderList;
// // // const OrderList = () => {
// // //   const [orders, setOrders] = useState([]);
// // //   const [selectedOrder, setSelectedOrder] = useState(null);
// // //   const [editingStatusId, setEditingStatusId] = useState(null);
// // //   const [selectedUid, setSelectedUid] = useState(null);
// // //   const statusInputRef = useRef(null);

// // //   useEffect(() => {
// // //     const fetchOrders = async () => {
// // //       const ordersRef = collection(db, "orders");
// // //       const querySnapshot = await getDocs(ordersRef);

// // //       const parsedData = [];
// // //       querySnapshot.forEach((doc) => {
// // //         const order = { id: doc.id, ...doc.data() };
// // //         const choice = JSON.parse(order.choice);
// // //         parsedData.push({ order, choice });
// // //       });

// // //       setOrders(parsedData);
// // //     };

// // //     fetchOrders();
// // //   }, []);

// // //   const handleStatusDoubleClick = (orderId) => {
// // //     if (editingStatusId === orderId) {
// // //       // Close status input if already editing
// // //       setEditingStatusId(null);
// // //     } else {
// // //       // Start editing status
// // //       setEditingStatusId(orderId);
// // //     }
// // //   };

// // //   const handleStatusChange = async (orderId, newStatus) => {
// // //     const orderDocRef = doc(db, "orders", orderId);
// // //     await updateDoc(orderDocRef, { status: newStatus });

// // //     setOrders((prevOrders) =>
// // //       prevOrders.map((order) => {
// // //         if (order.order.id === orderId) {
// // //           return { ...order, order: { ...order.order, status: newStatus } };
// // //         }
// // //         return order;
// // //       })
// // //     );
// // //   };

// // //   const handleStatusBlur = () => {
// // //     setEditingStatusId(null);
// // //   };

// // //   const handleOrderClick = (order) => {
// // //     if (selectedOrder === order) {
// // //       setSelectedOrder(null);
// // //       setSelectedUid(null);
// // //     } else {
// // //       setSelectedOrder(order);
// // //       setSelectedUid(order.order.uid);
// // //     }
// // //   };

// // //   useEffect(() => {
// // //     if (editingStatusId === selectedOrder?.order.id && statusInputRef.current) {
// // //       statusInputRef.current.focus();
// // //     }
// // //   }, [editingStatusId, selectedOrder]);

// // //   return (
// // //     <div className={css.orderListAllWrap}>
// // //       {orders.map((orderItem, index) => (
// // //         <div className={css.wrapAllAll} key={index}>
// // //           <div
// // //             className={css.orderWrapListinAdm}
// // //             onClick={() => handleOrderClick(orderItem)}
// // //           >
// // //             <p className={css.pOrderParag}>{orderItem.order.uid}</p>
// // //             {editingStatusId === orderItem.order.id ? (
// // //               <input
// // //                 type="text"
// // //                 value={orderItem.order.status}
// // //                 onChange={(e) =>
// // //                   handleStatusChange(orderItem.order.id, e.target.value)
// // //                 }
// // //                 onBlur={handleStatusBlur}
// // //                 ref={statusInputRef}
// // //               />
// // //             ) : (
// // //               <p
// // //                 className={css.pOrderParag}
// // //                 onDoubleClick={() =>
// // //                   handleStatusDoubleClick(orderItem.order.id)
// // //                 }
// // //               >
// // //                 {orderItem.order.status}
// // //               </p>
// // //             )}
// // //           </div>
// // //           {selectedUid === orderItem.order.uid && (
// // //             <div>
// // //               {orderItem.choice.map((tovar, index) => (
// // //                 <div key={index}>
// // //                   <p className={css.pOrderParag}>
// // //                     Данні замовника: {orderItem.order.surName}{" "}
// // //                     {orderItem.order.name} {orderItem.order.fatherName}
// // //                   </p>
// // //                   <p className={css.pOrderParag}>
// // //                     Спосіб оплати: {orderItem.order.pay}
// // //                   </p>
// // //                   <p className={css.pOrderParag}>
// // //                     Телефон: {orderItem.order.phone}
// // //                   </p>
// // //                   <p className={css.pOrderParag}>
// // //                     Адрес доставки: {orderItem.order.cityName},{" "}
// // //                     {orderItem.order.selectedDepartment}
// // //                   </p>
// // //                   <p className={css.pOrderParag}>
// // //                     Новий користувач:{" "}
// // //                     {orderItem.order.isNewBuyer === true ? "так" : "ні"}
// // //                   </p>
// // //                   <p className={css.pOrderParag}>
// // //                     Статус оплати:{" "}
// // //                     {orderItem.order.paymentStatus === "false"
// // //                       ? "не оплачено"
// // //                       : "оплачено"}
// // //                   </p>
// // //                   <p className={css.pOrderParag}>
// // //                     Данні для відправки: {orderItem.order.surNameOtr}{" "}
// // //                     {orderItem.order.nameOtr} {orderItem.order.fatherNameOtr}
// // //                   </p>
// // //                   <p className={css.pOrderParag}>
// // //                     Загальна вартість замовлення: {orderItem.order.totalPrice}
// // //                   </p>
// // //                   <p className={css.pOrderParag}>
// // //                     Статус замовлення: {orderItem.status}
// // //                   </p>

// // //                   {editingStatusId === orderItem.order.id ? (
// // //                     <input
// // //                       type="text"
// // //                       value={orderItem.order.status}
// // //                       onChange={(e) =>
// // //                         handleStatusChange(orderItem.order.id, e.target.value)
// // //                       }
// // //                       onBlur={handleStatusBlur}
// // //                       ref={statusInputRef}
// // //                     />
// // //                   ) : (
// // //                     <p
// // //                       onDoubleClick={() =>
// // //                         handleStatusDoubleClick(orderItem.order.id)
// // //                       }
// // //                     >
// // //                       Статус замовлення: {orderItem.order.status}
// // //                     </p>
// // //                   )}
// // //                   <p>Деталі замовлення:</p>
// // //                   {orderItem.choice.map((el, index) => (
// // //                     <div key={index} className={css.prodDescWrap}>
// // //                       <p className={css.pOrderParag}>
// // //                         Назва книги: {el.bookName}
// // //                       </p>
// // //                       <p className={css.pOrderParag}>
// // //                         Кількість: {el.quantity}
// // //                       </p>
// // //                     </div>
// // //                   ))}
// // //                 </div>
// // //               ))}
// // //             </div>
// // //           )}
// // //         </div>
// // //       ))}
// // //     </div>
// // //   );
// // // };

// // // export default OrderList;
// // import React, { useEffect, useMemo, useRef, useState } from "react";
// // import { collection, getDocs, doc, updateDoc } from "firebase/firestore";
// // import { db } from "../../firebase";
// // import styles from "./OrderList.module.css";

// // /** Фіксовані статуси */
// // const STATUS_OPTIONS = [
// //   "Очікує підтвердження",
// //   "Взято в роботу",
// //   "Підтверджено",
// //   "Комплектація",
// //   "Відправлено",
// //   "Доставлено",
// //   "Скасовано",
// //   "Повернення/обмін",
// // ];

// // /** Розміри сторінки */
// // const PAGE_SIZES = [10, 25, 50];

// // export default function OrderList() {
// //   const [orders, setOrders] = useState([]); // [{ order, choice }]
// //   const [expanded, setExpanded] = useState({}); // { [orderId]: bool }

// //   // редагування статусу
// //   const [editingStatusId, setEditingStatusId] = useState(null);
// //   const [statusDraft, setStatusDraft] = useState("");
// //   const statusRef = useRef(null);

// //   // редагування ТТН
// //   const [editingTtnId, setEditingTtnId] = useState(null);
// //   const [ttnDraft, setTtnDraft] = useState("");
// //   const ttnRef = useRef(null);

// //   // фільтри/сортування
// //   const [sortDir, setSortDir] = useState("desc"); // дата: asc|desc
// //   const [statusPin, setStatusPin] = useState("Усі"); // який статус вивести зверху
// //   const [statusOnly, setStatusOnly] = useState(false); // якщо true — показувати лише обраний статус

// //   const [dateFrom, setDateFrom] = useState(""); // YYYY-MM-DD
// //   const [dateTo, setDateTo] = useState(""); // YYYY-MM-DD

// //   // пагінація
// //   const [page, setPage] = useState(1); // 1-based
// //   const [pageSize, setPageSize] = useState(PAGE_SIZES[0]);

// //   useEffect(() => {
// //     (async () => {
// //       const snap = await getDocs(collection(db, "orders"));
// //       const rows = [];
// //       snap.forEach((d) => {
// //         const raw = { id: d.id, ...d.data() };
// //         let choice = [];
// //         try {
// //           if (Array.isArray(raw.choice)) choice = raw.choice;
// //           else if (typeof raw.choice === "string")
// //             choice = JSON.parse(raw.choice || "[]");
// //         } catch {
// //           choice = [];
// //         }
// //         rows.push({ order: raw, choice });
// //       });
// //       setOrders(rows);
// //     })();
// //   }, []);

// //   useEffect(() => {
// //     if (editingStatusId && statusRef.current) statusRef.current.focus();
// //   }, [editingStatusId]);
// //   useEffect(() => {
// //     if (editingTtnId && ttnRef.current) ttnRef.current.focus();
// //   }, [editingTtnId]);

// //   // скидати на 1 сторінку при зміні фільтрів/сортування/розміру
// //   useEffect(() => {
// //     setPage(1);
// //   }, [
// //     pageSize,
// //     sortDir,
// //     statusPin,
// //     statusOnly,
// //     dateFrom,
// //     dateTo,
// //     orders.length,
// //   ]);

// //   const toggleExpand = (id) => setExpanded((s) => ({ ...s, [id]: !s[id] }));

// //   /* ======== ПІПЕЛАЙН ДАНИХ: фільтри -> сортування -> пагінація ======== */
// //   const filtered = useMemo(() => {
// //     let arr = [...orders];

// //     // фільтр за статусом (лише цей статус)
// //     if (statusOnly && statusPin !== "Усі") {
// //       arr = arr.filter(({ order }) => (order.status || "") === statusPin);
// //     }

// //     // фільтр за періодом (дата створення)
// //     if (dateFrom || dateTo) {
// //       const fromMs = dateFrom ? dayStart(dateFrom) : -Infinity;
// //       const toMs = dateTo ? dayEnd(dateTo) : Infinity;
// //       arr = arr.filter(({ order }) => {
// //         const t = ts(order);
// //         return t >= fromMs && t <= toMs;
// //       });
// //     }

// //     return arr;
// //   }, [orders, statusOnly, statusPin, dateFrom, dateTo]);

// //   // сортування:
// //   // — за датою (asc/desc)
// //   // — + якщо обрано конкретний статус (statusPin != "Усі") і НЕ режим "лише цей статус",
// //   //     то замовлення з цим статусом піднімаємо догори, а всередині груп — за датою.
// //   const sorted = useMemo(() => {
// //     const arr = [...filtered];
// //     const cmpDate = (a, b) => {
// //       const A = ts(a.order),
// //         B = ts(b.order);
// //       return sortDir === "asc" ? A - B : B - A;
// //     };

// //     if (statusPin !== "Усі" && !statusOnly) {
// //       arr.sort((a, b) => {
// //         const pa = (a.order.status || "") === statusPin ? 0 : 1;
// //         const pb = (b.order.status || "") === statusPin ? 0 : 1;
// //         if (pa !== pb) return pa - pb;
// //         return cmpDate(a, b);
// //       });
// //     } else {
// //       arr.sort(cmpDate);
// //     }
// //     return arr;
// //   }, [filtered, sortDir, statusPin, statusOnly]);

// //   /* ======== ПАГІНАЦІЯ ======== */
// //   const totalPages = Math.max(1, Math.ceil(sorted.length / pageSize));
// //   const pageClamped = Math.min(page, totalPages);
// //   const start = (pageClamped - 1) * pageSize;
// //   const end = start + pageSize;
// //   const paged = sorted.slice(start, end);

// //   const goto = (p) => setPage(Math.min(Math.max(1, p), totalPages));

// //   /* ======== РЕДАГУВАННЯ СТАТУСУ ======== */
// //   const beginEditStatus = (o, e) => {
// //     e?.stopPropagation();
// //     setEditingStatusId(o.id);
// //     setStatusDraft(String(o.status || "Очікує підтвердження"));
// //   };
// //   const cancelEditStatus = () => {
// //     setEditingStatusId(null);
// //     setStatusDraft("");
// //   };
// //   const saveStatus = async (orderId) => {
// //     const v = statusDraft.trim();
// //     await updateDoc(doc(db, "orders", orderId), { status: v });
// //     setOrders((arr) =>
// //       arr.map((r) =>
// //         r.order.id === orderId ? { ...r, order: { ...r.order, status: v } } : r,
// //       ),
// //     );
// //     cancelEditStatus();
// //   };
// //   const onStatusKey = (e, orderId) => {
// //     if (e.key === "Enter") saveStatus(orderId);
// //     if (e.key === "Escape") cancelEditStatus();
// //   };

// //   /* ======== ТТН (Нова пошта) ======== */
// //   const canEditTTN = (order) =>
// //     ["Взято в роботу", "Відправлено", "Доставлено"].includes(
// //       order.status || "",
// //     );
// //   const beginEditTTN = (order) => {
// //     if (!canEditTTN(order)) return;
// //     setEditingTtnId(order.id);
// //     setTtnDraft(String(order.ttn || ""));
// //   };
// //   const cancelEditTTN = () => {
// //     setEditingTtnId(null);
// //     setTtnDraft("");
// //   };
// //   const saveTTN = async (orderId) => {
// //     const v = ttnDraft.trim();
// //     if (!/^\d{8,14}$/.test(v)) {
// //       alert("Введіть коректний номер ТТН (8–14 цифр).");
// //       return;
// //     }
// //     await updateDoc(doc(db, "orders", orderId), { ttn: v });
// //     setOrders((arr) =>
// //       arr.map((r) =>
// //         r.order.id === orderId ? { ...r, order: { ...r.order, ttn: v } } : r,
// //       ),
// //     );
// //     cancelEditTTN();
// //   };
// //   const onTtnKey = (e, orderId) => {
// //     if (e.key === "Enter") saveTTN(orderId);
// //     if (e.key === "Escape") cancelEditTTN();
// //   };

// //   return (
// //     <div className={styles.page}>
// //       <div className={styles.toolbar}>
// //         <h2 className={styles.title}>Замовлення</h2>

// //         <div className={styles.controls}>
// //           {/* ПЕРІОД ДАТИ */}
// //           <label className={styles.control}>
// //             <span>Період: з</span>
// //             <input
// //               type="date"
// //               value={dateFrom}
// //               onChange={(e) => setDateFrom(e.target.value)}
// //               className={styles.input}
// //             />
// //           </label>
// //           <label className={styles.control}>
// //             <span>до</span>
// //             <input
// //               type="date"
// //               value={dateTo}
// //               onChange={(e) => setDateTo(e.target.value)}
// //               className={styles.input}
// //             />
// //           </label>

// //           {/* СОРТУВАННЯ ДАТИ */}
// //           <label className={styles.control}>
// //             <span>Дата:</span>
// //             <select
// //               value={sortDir}
// //               onChange={(e) => setSortDir(e.target.value)}
// //               className={styles.select}
// //             >
// //               <option value="desc">спадання (нові зверху)</option>
// //               <option value="asc">зростання (старі зверху)</option>
// //             </select>
// //           </label>

// //           {/* «Сортування» по конкретному статусу */}
// //           <label className={styles.control}>
// //             <span>Статус вгорі:</span>
// //             <select
// //               value={statusPin}
// //               onChange={(e) => setStatusPin(e.target.value)}
// //               className={styles.select}
// //             >
// //               <option value="Усі">Усі</option>
// //               {STATUS_OPTIONS.map((s) => (
// //                 <option key={s} value={s}>
// //                   {s}
// //                 </option>
// //               ))}
// //             </select>
// //           </label>

// //           <label className={styles.controlCheck}>
// //             <input
// //               type="checkbox"
// //               checked={statusOnly}
// //               onChange={(e) => setStatusOnly(e.target.checked)}
// //             />
// //             <span>Показувати лише цей статус</span>
// //           </label>

// //           <label className={styles.control}>
// //             <span>На сторінці:</span>
// //             <select
// //               value={pageSize}
// //               onChange={(e) => setPageSize(Number(e.target.value))}
// //               className={styles.select}
// //             >
// //               {PAGE_SIZES.map((n) => (
// //                 <option key={n} value={n}>
// //                   {n}
// //                 </option>
// //               ))}
// //             </select>
// //           </label>
// //         </div>
// //       </div>

// //       <div className={styles.tableWrap}>
// //         <table className={styles.table}>
// //           <thead>
// //             <tr>
// //               <th className={styles.colCheck}></th>
// //               <th>Дата створення</th>
// //               <th>ID</th>
// //               <th>Покупець</th>
// //               <th>Статус</th>
// //               <th>Оплачено</th>
// //               <th>Скасовано</th>
// //               <th className={styles.colSum}>Сума</th>
// //               <th>Позиції</th>
// //             </tr>
// //           </thead>
// //           <tbody>
// //             {paged.map(({ order, choice }) => {
// //               const id = order.id;
// //               const isOpen = !!expanded[id];
// //               const paid = toBool(order.paymentStatus) ? "Так" : "Ні";
// //               const canceled = toBool(order.canceled) ? "Так" : "Ні";
// //               const sum = safeMoney(order.totalPrice);
// //               const buyer = fullName(
// //                 order.surName,
// //                 order.name,
// //                 order.fatherName,
// //               );

// //               return (
// //                 <React.Fragment key={id}>
// //                   <tr
// //                     className={styles.row}
// //                     onDoubleClick={() => toggleExpand(id)}
// //                   >
// //                     <td className={styles.colCheck}>
// //                       <input type="checkbox" />
// //                     </td>
// //                     <td>{fmtDate(ts(order))}</td>
// //                     <td className={styles.idCell}>№{shortId(id)}</td>
// //                     <td className={styles.buyerCell}>{buyer || "—"}</td>

// //                     <td
// //                       className={styles.statusCell}
// //                       onDoubleClick={(e) => beginEditStatus(order, e)}
// //                     >
// //                       {editingStatusId === id ? (
// //                         <select
// //                           ref={statusRef}
// //                           value={statusDraft || "Очікує підтвердження"}
// //                           onChange={(e) => setStatusDraft(e.target.value)}
// //                           onBlur={() => saveStatus(id)}
// //                           onKeyDown={(e) => onStatusKey(e, id)}
// //                           className={styles.statusSelect}
// //                         >
// //                           {STATUS_OPTIONS.map((opt) => (
// //                             <option key={opt} value={opt}>
// //                               {opt}
// //                             </option>
// //                           ))}
// //                         </select>
// //                       ) : (
// //                         <span className={styles.statusBadge}>
// //                           {order.status || "Очікує підтвердження"}
// //                         </span>
// //                       )}
// //                     </td>

// //                     <td>{paid}</td>
// //                     <td>{canceled}</td>
// //                     <td className={styles.colSum}>{sum}</td>
// //                     <td className={styles.positionsCell}>
// //                       {choice.length > 0 ? (
// //                         <>
// //                           {choice[0]?.bookName || choice[0]?.name || "Товар"}
// //                           {choice.length > 1 && (
// //                             <span className={styles.morePos}>
// //                               {" "}
// //                               +{choice.length - 1} поз.
// //                             </span>
// //                           )}
// //                         </>
// //                       ) : (
// //                         "—"
// //                       )}
// //                     </td>
// //                   </tr>

// //                   {isOpen && (
// //                     <tr className={styles.detailsRow}>
// //                       <td></td>
// //                       <td colSpan={8}>
// //                         <div className={styles.detailsBox}>
// //                           <div className={styles.colLeft}>
// //                             <h4>Дані замовника</h4>
// //                             <p>
// //                               <b>ПІБ:</b> {buyer || "—"}
// //                             </p>
// //                             <p>
// //                               <b>Телефон:</b> {order.phone || "—"}
// //                             </p>
// //                             <p>
// //                               <b>Спосіб оплати:</b> {order.pay || "—"}
// //                             </p>
// //                             <p>
// //                               <b>Адреса доставки:</b> {order.cityName || "—"}
// //                               {order.selectedDepartment
// //                                 ? ", " + order.selectedDepartment
// //                                 : ""}
// //                             </p>
// //                             <p>
// //                               <b>Новий користувач:</b>{" "}
// //                               {toBool(order.isNewBuyer) ? "так" : "ні"}
// //                             </p>
// //                             <p>
// //                               <b>Статус оплати:</b>{" "}
// //                               {toBool(order.paymentStatus)
// //                                 ? "оплачено"
// //                                 : "не оплачено"}
// //                             </p>
// //                             {(order.surNameOtr ||
// //                               order.nameOtr ||
// //                               order.fatherNameOtr) && (
// //                               <p>
// //                                 <b>Отримувач:</b>{" "}
// //                                 {fullName(
// //                                   order.surNameOtr,
// //                                   order.nameOtr,
// //                                   order.fatherNameOtr,
// //                                 )}
// //                               </p>
// //                             )}
// //                             <p>
// //                               <b>Загальна вартість замовлення:</b> {sum}
// //                             </p>
// //                             <p>
// //                               <b>Статус замовлення:</b> {order.status || "—"}
// //                             </p>
// //                           </div>

// //                           <div className={styles.colRight}>
// //                             <h4>Логістика</h4>
// //                             <div className={styles.ttnRow}>
// //                               <b>ТТН Нової пошти:&nbsp;</b>
// //                               {editingTtnId === id ? (
// //                                 <>
// //                                   <input
// //                                     ref={ttnRef}
// //                                     value={ttnDraft}
// //                                     onChange={(e) =>
// //                                       setTtnDraft(e.target.value)
// //                                     }
// //                                     onKeyDown={(e) => onTtnKey(e, id)}
// //                                     onBlur={() => saveTTN(id)}
// //                                     placeholder="Введіть номер ТТН (8–14 цифр)"
// //                                     className={styles.ttnInput}
// //                                   />
// //                                   <button
// //                                     type="button"
// //                                     className={styles.saveBtn}
// //                                     onMouseDown={(e) => e.preventDefault()}
// //                                     onClick={() => saveTTN(id)}
// //                                   >
// //                                     Зберегти
// //                                   </button>
// //                                   <button
// //                                     type="button"
// //                                     className={styles.cancelBtn}
// //                                     onMouseDown={(e) => e.preventDefault()}
// //                                     onClick={cancelEditTTN}
// //                                   >
// //                                     Скасувати
// //                                   </button>
// //                                 </>
// //                               ) : order.ttn ? (
// //                                 <>
// //                                   <a
// //                                     href={`https://tracking.novaposhta.ua/#/ua?cargo_number=${order.ttn}`}
// //                                     target="_blank"
// //                                     rel="noreferrer"
// //                                     className={styles.ttnLink}
// //                                   >
// //                                     {order.ttn}
// //                                   </a>
// //                                   <button
// //                                     type="button"
// //                                     className={styles.editBtn}
// //                                     onClick={() => beginEditTTN(order)}
// //                                   >
// //                                     Змінити
// //                                   </button>
// //                                 </>
// //                               ) : canEditTTN(order) ? (
// //                                 <button
// //                                   type="button"
// //                                   className={styles.addBtn}
// //                                   onClick={() => beginEditTTN(order)}
// //                                 >
// //                                   Додати ТТН
// //                                 </button>
// //                               ) : (
// //                                 <span>
// //                                   — (доступно після статусу «Взято в роботу»)
// //                                 </span>
// //                               )}
// //                             </div>

// //                             <h4>Позиції ({choice.length})</h4>
// //                             {choice.length === 0 && (
// //                               <div className={styles.empty}>Позицій немає</div>
// //                             )}
// //                             {choice.map((el, i) => (
// //                               <div key={i} className={styles.item}>
// //                                 <div className={styles.itemName}>
// //                                   {el.bookName || el.name || `Товар ${i + 1}`}
// //                                 </div>
// //                                 <div className={styles.itemQty}>
// //                                   x{el.quantity ?? 1}
// //                                 </div>
// //                                 {el.price ? (
// //                                   <div className={styles.itemPrice}>
// //                                     {safeMoney(el.price)}
// //                                   </div>
// //                                 ) : (
// //                                   <div />
// //                                 )}
// //                               </div>
// //                             ))}
// //                           </div>
// //                         </div>
// //                       </td>
// //                     </tr>
// //                   )}
// //                 </React.Fragment>
// //               );
// //             })}
// //           </tbody>
// //         </table>
// //       </div>

// //       {/* Пагінація */}
// //       <div className={styles.paginator}>
// //         <button
// //           className={styles.pageBtn}
// //           onClick={() => goto(1)}
// //           disabled={pageClamped === 1}
// //         >
// //           « Перша
// //         </button>
// //         <button
// //           className={styles.pageBtn}
// //           onClick={() => goto(pageClamped - 1)}
// //           disabled={pageClamped === 1}
// //         >
// //           ‹ Назад
// //         </button>
// //         <span className={styles.pageInfo}>
// //           Сторінка {pageClamped} з {totalPages}
// //         </span>
// //         <button
// //           className={styles.pageBtn}
// //           onClick={() => goto(pageClamped + 1)}
// //           disabled={pageClamped === totalPages}
// //         >
// //           Вперед ›
// //         </button>
// //         <button
// //           className={styles.pageBtn}
// //           onClick={() => goto(totalPages)}
// //           disabled={pageClamped === totalPages}
// //         >
// //           Остання »
// //         </button>
// //       </div>
// //     </div>
// //   );
// // }

// // /* ===== Хелпери ===== */
// // function ts(order) {
// //   const t =
// //     order?.createdAt || order?.date || order?.created_at || order?.created;
// //   if (!t) return 0;
// //   if (typeof t === "number") return t;
// //   if (typeof t === "string") return Date.parse(t) || 0;
// //   if (t?.seconds)
// //     return t.seconds * 1000 + Math.round((t.nanoseconds || 0) / 1e6);
// //   try {
// //     return new Date(t).getTime();
// //   } catch {
// //     return 0;
// //   }
// // }
// // function fmtDate(ms) {
// //   if (!ms) return "—";
// //   const d = new Date(ms);
// //   return d.toLocaleString("uk-UA", {
// //     year: "numeric",
// //     month: "2-digit",
// //     day: "2-digit",
// //     hour: "2-digit",
// //     minute: "2-digit",
// //   });
// // }
// // function fullName(sur, name, father) {
// //   return [sur, name, father].filter(Boolean).join(" ");
// // }
// // function toBool(v) {
// //   if (typeof v === "boolean") return v;
// //   if (typeof v === "number") return v !== 0;
// //   if (typeof v === "string") return v.toLowerCase() === "true" || v === "1";
// //   return false;
// // }
// // function safeMoney(v) {
// //   const n = Number(v || 0);
// //   if (!isFinite(n)) return "—";
// //   return new Intl.NumberFormat("uk-UA", {
// //     style: "currency",
// //     currency: "UAH",
// //     maximumFractionDigits: 0,
// //   }).format(n);
// // }
// // function shortId(id = "") {
// //   return String(id).slice(-4);
// // }
// // function dayStart(yyyy_mm_dd) {
// //   const d = new Date(yyyy_mm_dd + "T00:00:00");
// //   return d.getTime();
// // }
// // function dayEnd(yyyy_mm_dd) {
// //   const d = new Date(yyyy_mm_dd + "T23:59:59.999");
// //   return d.getTime();
// // }
// import React, { useEffect, useMemo, useRef, useState } from "react";
// import {
//   collection,
//   getDocs,
//   doc,
//   updateDoc,
//   serverTimestamp,
// } from "firebase/firestore";
// import { db } from "../../firebase";
// import styles from "./OrderList.module.css";

// /** Послідовність статусів (нова логіка) */
// const STATUS_OPTIONS = [
//   "Очікує підтвердження",
//   "Взято в роботу",
//   "ТТН НП внесено",
//   "Відправлено",
//   "Доставлено",
//   "Скасовано",
//   "Повернення/обмін",
// ];

// /** Розміри сторінки */
// const PAGE_SIZES = [10, 25, 50];

// /** Статуси, де ТТН можна редагувати */
// const TTN_EDITABLE_STATUSES = new Set([
//   "Взято в роботу",
//   "ТТН НП внесено",
//   "Відправлено",
//   "Доставлено",
// ]);

// /** Статуси, де ТТН має бути обовʼязково */
// const TTN_REQUIRED_STATUSES = new Set([
//   "ТТН НП внесено",
//   "Відправлено",
//   "Доставлено",
// ]);

// export default function OrderList() {
//   const [orders, setOrders] = useState([]); // [{ order, choice }]
//   const [expanded, setExpanded] = useState({}); // { [orderId]: bool }

//   // редагування статусу
//   const [editingStatusId, setEditingStatusId] = useState(null);
//   const [statusDraft, setStatusDraft] = useState("");
//   const statusRef = useRef(null);

//   // редагування ТТН
//   const [editingTtnId, setEditingTtnId] = useState(null);
//   const [ttnDraft, setTtnDraft] = useState("");
//   const ttnRef = useRef(null);

//   // фільтри/сортування
//   const [sortDir, setSortDir] = useState("desc"); // дата: asc|desc
//   const [statusPin, setStatusPin] = useState("Усі"); // який статус вивести зверху
//   const [statusOnly, setStatusOnly] = useState(false); // якщо true — показувати лише обраний статус
//   const [dateFrom, setDateFrom] = useState(""); // YYYY-MM-DD
//   const [dateTo, setDateTo] = useState(""); // YYYY-MM-DD

//   // пагінація
//   const [page, setPage] = useState(1);
//   const [pageSize, setPageSize] = useState(PAGE_SIZES[0]);

//   /* ================== LOAD ORDERS ================== */
//   useEffect(() => {
//     (async () => {
//       try {
//         const snap = await getDocs(collection(db, "orders"));
//         const rows = [];

//         snap.forEach((d) => {
//           const raw = { id: d.id, ...d.data() };
//           const choice = parseChoice(raw?.choice);
//           rows.push({ order: raw, choice });
//         });

//         setOrders(rows);
//       } catch (e) {
//         console.error("OrderList load error:", e);
//         setOrders([]);
//       }
//     })();
//   }, []);

//   useEffect(() => {
//     if (editingStatusId && statusRef.current) statusRef.current.focus();
//   }, [editingStatusId]);

//   useEffect(() => {
//     if (editingTtnId && ttnRef.current) ttnRef.current.focus();
//   }, [editingTtnId]);

//   useEffect(() => {
//     setPage(1);
//   }, [
//     pageSize,
//     sortDir,
//     statusPin,
//     statusOnly,
//     dateFrom,
//     dateTo,
//     orders.length,
//   ]);

//   const toggleExpand = (id) => setExpanded((s) => ({ ...s, [id]: !s[id] }));

//   /* ======== ФІЛЬТРИ ======== */
//   const filtered = useMemo(() => {
//     let arr = [...orders];

//     if (statusOnly && statusPin !== "Усі") {
//       arr = arr.filter(({ order }) => getStatus(order) === statusPin);
//     }

//     if (dateFrom || dateTo) {
//       const fromMs = dateFrom ? dayStart(dateFrom) : -Infinity;
//       const toMs = dateTo ? dayEnd(dateTo) : Infinity;

//       arr = arr.filter(({ order }) => {
//         const t = ts(order);
//         return t >= fromMs && t <= toMs;
//       });
//     }

//     return arr;
//   }, [orders, statusOnly, statusPin, dateFrom, dateTo]);

//   /* ======== СОРТ ======== */
//   const sorted = useMemo(() => {
//     const arr = [...filtered];

//     const cmpDate = (a, b) => {
//       const A = ts(a.order);
//       const B = ts(b.order);
//       return sortDir === "asc" ? A - B : B - A;
//     };

//     if (statusPin !== "Усі" && !statusOnly) {
//       arr.sort((a, b) => {
//         const pa = getStatus(a.order) === statusPin ? 0 : 1;
//         const pb = getStatus(b.order) === statusPin ? 0 : 1;
//         if (pa !== pb) return pa - pb;
//         return cmpDate(a, b);
//       });
//     } else {
//       arr.sort(cmpDate);
//     }

//     return arr;
//   }, [filtered, sortDir, statusPin, statusOnly]);

//   /* ======== ПАГІНАЦІЯ ======== */
//   const totalPages = Math.max(1, Math.ceil(sorted.length / pageSize));
//   const pageClamped = Math.min(page, totalPages);
//   const start = (pageClamped - 1) * pageSize;
//   const end = start + pageSize;
//   const paged = sorted.slice(start, end);

//   const goto = (p) => setPage(Math.min(Math.max(1, p), totalPages));

//   /* ================== STATUS EDIT ================== */
//   const beginEditStatus = (order, e) => {
//     e?.stopPropagation?.();
//     setEditingStatusId(order.id);
//     setStatusDraft(getStatus(order));
//   };

//   const cancelEditStatus = () => {
//     setEditingStatusId(null);
//     setStatusDraft("");
//   };

//   const saveStatusToDb = async (orderId, nextStatusRaw) => {
//     const nextStatus =
//       String(nextStatusRaw || "").trim() || "Очікує підтвердження";

//     const currentRow = orders.find((r) => r.order.id === orderId);
//     const currentOrder = currentRow?.order || {};

//     const currentTtn = getTtn(currentOrder);

//     // Якщо статус вимагає ТТН — без ТТН не даємо зберегти
//     if (
//       TTN_REQUIRED_STATUSES.has(nextStatus) &&
//       !String(currentTtn || "").trim()
//     ) {
//       alert("Спочатку внесіть номер ТТН Нової пошти, потім змініть статус.");
//       return;
//     }

//     const canceled = nextStatus === "Скасовано";
//     const nowISO = new Date().toISOString();

//     await updateDoc(doc(db, "orders", orderId), {
//       status: nextStatus,
//       canceled,
//       updatedAt: serverTimestamp(),
//       updatedAtISO: nowISO,

//       statusFlow: {
//         current: nextStatus,
//         updatedAtISO: nowISO,
//       },
//     });

//     setOrders((arr) =>
//       arr.map((r) =>
//         r.order.id === orderId
//           ? {
//               ...r,
//               order: {
//                 ...r.order,
//                 status: nextStatus,
//                 canceled,
//                 updatedAtISO: nowISO,
//                 statusFlow: {
//                   ...(r.order?.statusFlow || {}),
//                   current: nextStatus,
//                   updatedAtISO: nowISO,
//                 },
//               },
//             }
//           : r,
//       ),
//     );
//   };

//   const saveStatus = async (orderId) => {
//     try {
//       await saveStatusToDb(orderId, statusDraft);
//       cancelEditStatus();
//     } catch (e) {
//       console.error("Save status error:", e);
//       alert("Не вдалося зберегти статус.");
//     }
//   };

//   const onStatusKey = (e, orderId) => {
//     if (e.key === "Enter") saveStatus(orderId);
//     if (e.key === "Escape") cancelEditStatus();
//   };

//   /* ================== TTN EDIT ================== */
//   const canEditTTN = (order) => TTN_EDITABLE_STATUSES.has(getStatus(order));

//   const beginEditTTN = (order) => {
//     if (!canEditTTN(order)) return;
//     setEditingTtnId(order.id);
//     setTtnDraft(String(getTtn(order) || ""));
//   };

//   const cancelEditTTN = () => {
//     setEditingTtnId(null);
//     setTtnDraft("");
//   };

//   const saveTTNToDb = async (orderId, ttnValue, options = {}) => {
//     const normalized = String(ttnValue || "")
//       .replace(/\D/g, "")
//       .trim();

//     if (!/^\d{8,14}$/.test(normalized)) {
//       alert("Введіть коректний номер ТТН (8–14 цифр).");
//       return;
//     }

//     const row = orders.find((r) => r.order.id === orderId);
//     const currentOrder = row?.order || {};
//     const currentStatus = getStatus(currentOrder);

//     let nextStatus = currentStatus;
//     if (options.setStatusAfterSave === true) {
//       nextStatus = "ТТН НП внесено";
//     }

//     const nowISO = new Date().toISOString();

//     await updateDoc(doc(db, "orders", orderId), {
//       // legacy
//       ttn: normalized,
//       status: nextStatus,

//       // structured
//       updatedAt: serverTimestamp(),
//       updatedAtISO: nowISO,

//       delivery: {
//         ...(currentOrder?.delivery || {}),
//         ttn: normalized,
//       },

//       logistics: {
//         ...(currentOrder?.logistics || {}),
//         provider: "Нова пошта",
//         providerLabel: "Нова пошта",
//         ttn: normalized,
//         updatedAtISO: nowISO,
//       },
//     });

//     setOrders((arr) =>
//       arr.map((r) => {
//         if (r.order.id !== orderId) return r;

//         return {
//           ...r,
//           order: {
//             ...r.order,
//             ttn: normalized,
//             status: nextStatus,
//             updatedAtISO: nowISO,
//             delivery: {
//               ...(r.order?.delivery || {}),
//               ttn: normalized,
//             },
//             logistics: {
//               ...(r.order?.logistics || {}),
//               provider: "Нова пошта",
//               providerLabel: "Нова пошта",
//               ttn: normalized,
//               updatedAtISO: nowISO,
//             },
//           },
//         };
//       }),
//     );
//   };

//   const saveTTN = async (orderId) => {
//     try {
//       await saveTTNToDb(orderId, ttnDraft, { setStatusAfterSave: false });
//       cancelEditTTN();
//     } catch (e) {
//       console.error("Save TTN error:", e);
//       alert("Не вдалося зберегти ТТН.");
//     }
//   };

//   const saveTTNAndSetStatus = async (orderId) => {
//     try {
//       await saveTTNToDb(orderId, ttnDraft, { setStatusAfterSave: true });
//       cancelEditTTN();
//     } catch (e) {
//       console.error("Save TTN + status error:", e);
//       alert("Не вдалося зберегти ТТН і оновити статус.");
//     }
//   };

//   const onTtnKey = (e, orderId) => {
//     if (e.key === "Enter") saveTTN(orderId);
//     if (e.key === "Escape") cancelEditTTN();
//   };

//   /* ================== RENDER ================== */
//   return (
//     <div className={styles.page}>
//       <div className={styles.toolbar}>
//         <h2 className={styles.title}>Замовлення</h2>

//         <div className={styles.controls}>
//           <label className={styles.control}>
//             <span>Період: з</span>
//             <input
//               type="date"
//               value={dateFrom}
//               onChange={(e) => setDateFrom(e.target.value)}
//               className={styles.input}
//             />
//           </label>

//           <label className={styles.control}>
//             <span>до</span>
//             <input
//               type="date"
//               value={dateTo}
//               onChange={(e) => setDateTo(e.target.value)}
//               className={styles.input}
//             />
//           </label>

//           <label className={styles.control}>
//             <span>Дата:</span>
//             <select
//               value={sortDir}
//               onChange={(e) => setSortDir(e.target.value)}
//               className={styles.select}
//             >
//               <option value="desc">спадання (нові зверху)</option>
//               <option value="asc">зростання (старі зверху)</option>
//             </select>
//           </label>

//           <label className={styles.control}>
//             <span>Статус вгорі:</span>
//             <select
//               value={statusPin}
//               onChange={(e) => setStatusPin(e.target.value)}
//               className={styles.select}
//             >
//               <option value="Усі">Усі</option>
//               {STATUS_OPTIONS.map((s) => (
//                 <option key={s} value={s}>
//                   {s}
//                 </option>
//               ))}
//             </select>
//           </label>

//           <label className={styles.controlCheck}>
//             <input
//               type="checkbox"
//               checked={statusOnly}
//               onChange={(e) => setStatusOnly(e.target.checked)}
//             />
//             <span>Показувати лише цей статус</span>
//           </label>

//           <label className={styles.control}>
//             <span>На сторінці:</span>
//             <select
//               value={pageSize}
//               onChange={(e) => setPageSize(Number(e.target.value))}
//               className={styles.select}
//             >
//               {PAGE_SIZES.map((n) => (
//                 <option key={n} value={n}>
//                   {n}
//                 </option>
//               ))}
//             </select>
//           </label>
//         </div>
//       </div>

//       <div className={styles.tableWrap}>
//         <table className={styles.table}>
//           <thead>
//             <tr>
//               <th className={styles.colCheck}></th>
//               <th>Дата створення</th>
//               <th>ID</th>
//               <th>Покупець</th>
//               <th>Статус</th>
//               <th>Оплата</th>
//               <th>Рахунок</th>
//               <th>Оплачено</th>
//               <th>Скасовано</th>
//               <th className={styles.colSum}>Сума</th>
//               <th>Позиції</th>
//             </tr>
//           </thead>

//           <tbody>
//             {paged.map(({ order, choice }) => {
//               const id = order.id;
//               const isOpen = !!expanded[id];

//               const status = getStatus(order);
//               const paid = isPaidOrder(order) ? "Так" : "Ні";
//               const canceled = isCanceledOrder(order) ? "Так" : "Ні";

//               const sum = safeMoney(getOrderTotal(order));
//               const buyer = getBuyerFullName(order);

//               const isBiz = isBusinessPartnerOrder(order);
//               const payLabel = isBiz ? getPaymentMethodLabel(order) : "—";
//               const invoice = isBiz ? getInvoiceInfo(order) : null;

//               const showInvoice =
//                 isBiz &&
//                 getPaymentMethodRaw(order) === "invoice" &&
//                 invoice?.invoiceUrl;

//               const invoiceCell = !isBiz ? (
//                 "—"
//               ) : getPaymentMethodRaw(order) !== "invoice" ? (
//                 "—"
//               ) : invoice?.invoiceUrl ? (
//                 <a
//                   href={invoice.invoiceUrl}
//                   target="_blank"
//                   rel="noreferrer"
//                   title="Відкрити рахунок"
//                 >
//                   {invoice.invoiceNumber
//                     ? invoice.invoiceNumber
//                     : "Відкрити рахунок"}
//                 </a>
//               ) : (
//                 "ще не сформовано"
//               );

//               return (
//                 <React.Fragment key={id}>
//                   <tr
//                     className={styles.row}
//                     onDoubleClick={() => toggleExpand(id)}
//                   >
//                     <td className={styles.colCheck}>
//                       <input type="checkbox" />
//                     </td>

//                     <td>{fmtDate(ts(order))}</td>

//                     <td className={styles.idCell}>
//                       №{shortId(order.id || order.orderId || order.uid)}
//                     </td>

//                     <td className={styles.buyerCell}>{buyer || "—"}</td>

//                     <td
//                       className={styles.statusCell}
//                       onDoubleClick={(e) => beginEditStatus(order, e)}
//                     >
//                       {editingStatusId === id ? (
//                         <select
//                           ref={statusRef}
//                           value={statusDraft || "Очікує підтвердження"}
//                           onChange={(e) => setStatusDraft(e.target.value)}
//                           onBlur={() => saveStatus(id)}
//                           onKeyDown={(e) => onStatusKey(e, id)}
//                           className={styles.statusSelect}
//                         >
//                           {STATUS_OPTIONS.map((opt) => (
//                             <option key={opt} value={opt}>
//                               {opt}
//                             </option>
//                           ))}
//                         </select>
//                       ) : (
//                         <span className={styles.statusBadge}>
//                           {status || "Очікує підтвердження"}
//                         </span>
//                       )}
//                     </td>

//                     {/* Оплата (тільки для бізнес-партнера) */}
//                     <td>{payLabel}</td>

//                     {/* Рахунок (тільки якщо invoice) */}
//                     <td>{invoiceCell}</td>

//                     <td>{paid}</td>
//                     <td>{canceled}</td>
//                     <td className={styles.colSum}>{sum}</td>

//                     <td className={styles.positionsCell}>
//                       {choice.length > 0 ? (
//                         <>
//                           {choice[0]?.bookName || choice[0]?.name || "Товар"}
//                           {choice.length > 1 && (
//                             <span className={styles.morePos}>
//                               {" "}
//                               +{choice.length - 1} поз.
//                             </span>
//                           )}
//                         </>
//                       ) : (
//                         "—"
//                       )}
//                     </td>
//                   </tr>

//                   {isOpen && (
//                     <tr className={styles.detailsRow}>
//                       <td></td>
//                       <td colSpan={10}>
//                         <div className={styles.detailsBox}>
//                           {/* LEFT */}
//                           <div className={styles.colLeft}>
//                             <h4>Дані замовника</h4>

//                             <p>
//                               <b>ПІБ:</b> {buyer || "—"}
//                             </p>

//                             <p>
//                               <b>Телефон:</b> {getBuyerPhone(order) || "—"}
//                             </p>

//                             <p>
//                               <b>Отримувач:</b>{" "}
//                               {getReceiverFullName(order) || "—"}
//                             </p>

//                             <p>
//                               <b>Телефон отримувача:</b>{" "}
//                               {getReceiverPhone(order) || "—"}
//                             </p>

//                             <p>
//                               <b>Категорія:</b> {getUserCategory(order) || "—"}
//                             </p>

//                             <p>
//                               <b>Спосіб оплати:</b>{" "}
//                               {isBiz
//                                 ? getPaymentMethodLabel(order)
//                                 : order.pay || "—"}
//                             </p>

//                             <p>
//                               <b>Статус оплати:</b>{" "}
//                               {getPaymentStatusLabel(order)}
//                             </p>

//                             <p>
//                               <b>Провайдер оплати:</b>{" "}
//                               {getPaymentProviderLabel(order)}
//                             </p>

//                             {/* Якщо бізнес + оплата по рахунку => показуємо рахунок */}
//                             {isBiz &&
//                               getPaymentMethodRaw(order) === "invoice" && (
//                                 <div style={{ marginTop: 10 }}>
//                                   <p>
//                                     <b>Рахунок:</b>{" "}
//                                     {invoice?.invoiceNumber || "—"}
//                                     {invoice?.invoiceDate
//                                       ? ` (дата: ${invoice.invoiceDate})`
//                                       : ""}
//                                   </p>

//                                   {invoice?.invoiceUrl ? (
//                                     <p>
//                                       <a
//                                         href={invoice.invoiceUrl}
//                                         target="_blank"
//                                         rel="noreferrer"
//                                       >
//                                         Відкрити рахунок{" "}
//                                         {invoice?.fileType
//                                           ? `(.${invoice.fileType})`
//                                           : ""}
//                                       </a>
//                                     </p>
//                                   ) : (
//                                     <p style={{ color: "#777" }}>
//                                       Рахунок ще не сформовано.
//                                     </p>
//                                   )}
//                                 </div>
//                               )}

//                             <p>
//                               <b>Адреса доставки:</b> {getDeliveryLine(order)}
//                             </p>

//                             <p>
//                               <b>Загальна вартість:</b> {sum}
//                             </p>

//                             <p>
//                               <b>Статус замовлення:</b> {status || "—"}
//                             </p>

//                             <p>
//                               <b>Створено:</b>{" "}
//                               {fmtDate(ts(order)) ||
//                                 order?.createdAtDisplay ||
//                                 "—"}
//                             </p>
//                           </div>

//                           {/* RIGHT */}
//                           <div className={styles.colRight}>
//                             <h4>Логістика</h4>

//                             <p>
//                               <b>Служба доставки:</b>{" "}
//                               {getDeliveryProviderLabel(order)}
//                             </p>

//                             <div className={styles.ttnRow}>
//                               <b>ТТН Нової пошти:&nbsp;</b>

//                               {editingTtnId === id ? (
//                                 <>
//                                   <input
//                                     ref={ttnRef}
//                                     value={ttnDraft}
//                                     onChange={(e) =>
//                                       setTtnDraft(e.target.value)
//                                     }
//                                     onKeyDown={(e) => onTtnKey(e, id)}
//                                     placeholder="Введіть номер ТТН (8–14 цифр)"
//                                     className={styles.ttnInput}
//                                   />

//                                   <button
//                                     type="button"
//                                     className={styles.saveBtn}
//                                     onMouseDown={(e) => e.preventDefault()}
//                                     onClick={() => saveTTN(id)}
//                                     title="Зберегти ТТН"
//                                   >
//                                     Зберегти ТТН
//                                   </button>

//                                   <button
//                                     type="button"
//                                     className={styles.saveBtn}
//                                     onMouseDown={(e) => e.preventDefault()}
//                                     onClick={() => saveTTNAndSetStatus(id)}
//                                     title="Зберегти ТТН і поставити статус 'ТТН НП внесено'"
//                                   >
//                                     ТТН НП внесено
//                                   </button>

//                                   <button
//                                     type="button"
//                                     className={styles.cancelBtn}
//                                     onMouseDown={(e) => e.preventDefault()}
//                                     onClick={cancelEditTTN}
//                                   >
//                                     Скасувати
//                                   </button>
//                                 </>
//                               ) : getTtn(order) ? (
//                                 <>
//                                   <a
//                                     href={`https://tracking.novaposhta.ua/#/ua?cargo_number=${getTtn(
//                                       order,
//                                     )}`}
//                                     target="_blank"
//                                     rel="noreferrer"
//                                     className={styles.ttnLink}
//                                   >
//                                     {getTtn(order)}
//                                   </a>

//                                   {canEditTTN(order) && (
//                                     <button
//                                       type="button"
//                                       className={styles.editBtn}
//                                       onClick={() => beginEditTTN(order)}
//                                     >
//                                       Змінити
//                                     </button>
//                                   )}
//                                 </>
//                               ) : canEditTTN(order) ? (
//                                 <button
//                                   type="button"
//                                   className={styles.addBtn}
//                                   onClick={() => beginEditTTN(order)}
//                                 >
//                                   Додати ТТН
//                                 </button>
//                               ) : (
//                                 <span>
//                                   — (доступно після статусу «Взято в роботу»)
//                                 </span>
//                               )}
//                             </div>

//                             <h4>Позиції ({choice.length})</h4>

//                             {choice.length === 0 && (
//                               <div className={styles.empty}>Позицій немає</div>
//                             )}

//                             {choice.map((el, i) => {
//                               const price =
//                                 el?.finalPrice ??
//                                 el?.price ??
//                                 el?.unitPrice ??
//                                 0;
//                               const qty =
//                                 Number(el?.quantity ?? el?.qty ?? 1) || 1;

//                               return (
//                                 <div key={i} className={styles.item}>
//                                   <div className={styles.itemName}>
//                                     {el?.bookName ||
//                                       el?.name ||
//                                       `Товар ${i + 1}`}
//                                   </div>
//                                   <div className={styles.itemQty}>x{qty}</div>
//                                   <div className={styles.itemPrice}>
//                                     {safeMoney(price)}
//                                   </div>
//                                 </div>
//                               );
//                             })}
//                           </div>
//                         </div>
//                       </td>
//                     </tr>
//                   )}
//                 </React.Fragment>
//               );
//             })}

//             {paged.length === 0 && (
//               <tr>
//                 <td colSpan={11} style={{ padding: 16, textAlign: "center" }}>
//                   Замовлень не знайдено
//                 </td>
//               </tr>
//             )}
//           </tbody>
//         </table>
//       </div>

//       {/* ПАГІНАЦІЯ */}
//       <div className={styles.paginator}>
//         <button
//           className={styles.pageBtn}
//           onClick={() => goto(1)}
//           disabled={pageClamped === 1}
//         >
//           « Перша
//         </button>

//         <button
//           className={styles.pageBtn}
//           onClick={() => goto(pageClamped - 1)}
//           disabled={pageClamped === 1}
//         >
//           ‹ Назад
//         </button>

//         <span className={styles.pageInfo}>
//           Сторінка {pageClamped} з {totalPages}
//         </span>

//         <button
//           className={styles.pageBtn}
//           onClick={() => goto(pageClamped + 1)}
//           disabled={pageClamped === totalPages}
//         >
//           Вперед ›
//         </button>

//         <button
//           className={styles.pageBtn}
//           onClick={() => goto(totalPages)}
//           disabled={pageClamped === totalPages}
//         >
//           Остання »
//         </button>
//       </div>
//     </div>
//   );
// }

// /* =========================================================
//  * HELPERS
//  * ========================================================= */

// function parseChoice(rawChoice) {
//   try {
//     if (Array.isArray(rawChoice)) return rawChoice;
//     if (typeof rawChoice === "string") return JSON.parse(rawChoice || "[]");
//   } catch (e) {
//     console.warn("parseChoice error:", e);
//   }
//   return [];
// }

// function getStatus(order = {}) {
//   return order?.statusFlow?.current || order?.status || "Очікує підтвердження";
// }

// function getTtn(order = {}) {
//   return order?.ttn || order?.logistics?.ttn || order?.delivery?.ttn || "";
// }

// /** Категорія користувача */
// function getUserCategory(order = {}) {
//   return order?.userCategory || order?.userSnapshot?.category || "";
// }

// /** Бізнес-партнер? */
// function isBusinessPartnerOrder(order = {}) {
//   const c = String(getUserCategory(order)).toLowerCase();
//   return c.includes("бізнес") && c.includes("партнер");
// }

// function getOrderTotal(order = {}) {
//   const candidates = [
//     order?.pricing?.finishPrice,
//     order?.finishPrice,
//     order?.pricing?.totalPrice,
//     order?.totalPrice,
//   ];
//   for (const v of candidates) {
//     const n = Number(v);
//     if (Number.isFinite(n)) return n;
//   }
//   return 0;
// }

// function getBuyerFullName(order = {}) {
//   return (
//     order?.buyer?.fullName ||
//     joinName(order?.buyer?.name, order?.buyer?.surName) ||
//     order?.userSnapshot?.displayName ||
//     joinName(order?.surName, order?.name, order?.fatherName) ||
//     "—"
//   );
// }

// function getBuyerPhone(order = {}) {
//   return (
//     order?.buyer?.phone || order?.userSnapshot?.phone || order?.phone || "—"
//   );
// }

// function getReceiverFullName(order = {}) {
//   if (order?.receiver?.sameAsBuyer === true) return getBuyerFullName(order);
//   return (
//     order?.receiver?.fullName ||
//     joinName(order?.receiver?.name, order?.receiver?.surName) ||
//     joinName(order?.surNameOtr, order?.nameOtr, order?.fatherNameOtr) ||
//     "—"
//   );
// }

// function getReceiverPhone(order = {}) {
//   if (order?.receiver?.sameAsBuyer === true) return getBuyerPhone(order);
//   return order?.receiver?.phone || order?.phoneOtr || "—";
// }

// /** method raw */
// function getPaymentMethodRaw(order = {}) {
//   const raw =
//     order?.payment?.method || order?.paymentMethod || order?.pay || "";
//   const v = String(raw).toLowerCase().trim();
//   if (v.includes("invoice") || v.includes("рах")) return "invoice";
//   if (v.includes("card") || v.includes("карт")) return "card";
//   return v || "";
// }

// function getPaymentMethodLabel(order = {}) {
//   const m = getPaymentMethodRaw(order);
//   if (m === "invoice") return "По рахунку";
//   if (m === "card") return "Картою";
//   return m || "—";
// }

// function getPaymentProviderLabel(order = {}) {
//   return (
//     order?.payment?.provider ||
//     order?.paymentProvider ||
//     (getPaymentMethodRaw(order) === "invoice" ? "invoice" : "liqpay") ||
//     "—"
//   );
// }

// function getPaymentStatusRaw(order = {}) {
//   return (
//     order?.payment?.status || order?.paymentStatus || order?.liqpayStatus || ""
//   );
// }

// function isPaidOrder(order = {}) {
//   if (order?.isPaid === true) return true;
//   const raw = String(getPaymentStatusRaw(order)).toLowerCase().trim();
//   return ["paid", "success", "sandbox", "true", "1"].includes(raw);
// }

// function getPaymentStatusLabel(order = {}) {
//   if (isPaidOrder(order)) return "оплачено";
//   const raw = String(getPaymentStatusRaw(order)).toLowerCase().trim();
//   if (!raw) return "не оплачено";
//   if (raw === "pending") return "очікує оплату";
//   if (raw === "invoice_pending") return "очікує рахунок";
//   if (raw === "invoice_created") return "рахунок сформовано";
//   if (raw === "failure" || raw === "error") return "помилка";
//   return raw;
// }

// /** Інвойс: беремо з order, якщо є */
// function getInvoiceInfo(order = {}) {
//   const invoiceUrl =
//     order?.invoiceUrl ||
//     order?.invoiceMeta?.invoiceUrl ||
//     order?.invoice?.invoiceUrl ||
//     "";

//   const invoiceNumber =
//     order?.invoiceNumber ||
//     order?.invoiceMeta?.invoiceNumber ||
//     order?.invoice?.invoiceNumber ||
//     "";

//   const invoiceDate =
//     order?.invoiceDate ||
//     order?.invoiceMeta?.invoiceDate ||
//     order?.invoice?.invoiceDate ||
//     "";

//   const fileType =
//     order?.invoiceFileType ||
//     order?.invoiceMeta?.fileType ||
//     order?.invoice?.fileType ||
//     (String(invoiceUrl).endsWith(".xlsx") ? "xlsx" : "");

//   return {
//     invoiceUrl: String(invoiceUrl || ""),
//     invoiceNumber: String(invoiceNumber || ""),
//     invoiceDate: String(invoiceDate || ""),
//     fileType: String(fileType || ""),
//   };
// }

// function getDeliveryProviderLabel(order = {}) {
//   return (
//     order?.logistics?.providerLabel ||
//     order?.delivery?.methodName ||
//     order?.delivery?.provider ||
//     "Нова пошта"
//   );
// }

// function getDeliveryLine(order = {}) {
//   const city = order?.delivery?.cityName || order?.cityName || "";
//   const warehouse =
//     order?.delivery?.warehouse || order?.selectedDepartment || "";
//   const area = order?.delivery?.cityArea || "";
//   const parts = [city, area, warehouse].filter(Boolean);
//   return parts.length ? parts.join(", ") : "—";
// }

// function isCanceledOrder(order = {}) {
//   if (order?.canceled === true) return true;
//   return getStatus(order) === "Скасовано";
// }

// function joinName(...parts) {
//   return parts
//     .map((x) => String(x || "").trim())
//     .filter(Boolean)
//     .join(" ");
// }

// function ts(order = {}) {
//   const candidates = [
//     order?.createdAtClient,
//     order?.createdAtISO,
//     order?.createdAt,
//     order?.date,
//     order?.created_at,
//     order?.created,
//   ];
//   for (const t of candidates) {
//     const parsed = toTimestamp(t);
//     if (parsed > 0) return parsed;
//   }
//   return 0;
// }

// function toTimestamp(t) {
//   if (!t) return 0;

//   if (typeof t === "number") return Number.isFinite(t) ? t : 0;
//   if (typeof t === "string") {
//     const p = Date.parse(t);
//     return Number.isFinite(p) ? p : 0;
//   }
//   if (t?.seconds)
//     return t.seconds * 1000 + Math.round((t.nanoseconds || 0) / 1e6);

//   try {
//     const d = new Date(t).getTime();
//     return Number.isFinite(d) ? d : 0;
//   } catch {
//     return 0;
//   }
// }

// function fmtDate(ms) {
//   if (!ms) return "—";
//   const d = new Date(ms);
//   return d.toLocaleString("uk-UA", {
//     year: "numeric",
//     month: "2-digit",
//     day: "2-digit",
//     hour: "2-digit",
//     minute: "2-digit",
//   });
// }

// function safeMoney(v) {
//   const n = Number(v || 0);
//   if (!Number.isFinite(n)) return "—";
//   return new Intl.NumberFormat("uk-UA", {
//     style: "currency",
//     currency: "UAH",
//     maximumFractionDigits: 0,
//   }).format(n);
// }

// function shortId(id = "") {
//   const s = String(id || "");
//   return s.slice(-6) || "—";
// }

// function dayStart(yyyy_mm_dd) {
//   const d = new Date(`${yyyy_mm_dd}T00:00:00`);
//   return d.getTime();
// }

// function dayEnd(yyyy_mm_dd) {
//   const d = new Date(`${yyyy_mm_dd}T23:59:59.999`);
//   return d.getTime();
// }
// src/components/OrderList/OrderList.jsx

import React from "react";
import styles from "./OrderList.module.css";

import { PAGE_SIZES } from "./OrderListFile/constants";
import { useOrdersManager } from "./OrderListFile/useOrdersManager";
import OrderRow from "./OrderListFile/OrderRow";

export default function OrderList() {
  const mgr = useOrdersManager(PAGE_SIZES[0]);

  return (
    <div className={styles.page}>
      {/* TOOLBAR (в цьому файлі, без окремого компоненту) */}
      <div className={styles.toolbar}>
        <h2 className={styles.title}>Замовлення</h2>

        <div className={styles.controls}>
          <label className={styles.control}>
            <span>Період: з</span>
            <input
              type="date"
              value={mgr.dateFrom}
              onChange={(e) => mgr.setDateFrom(e.target.value)}
              className={styles.input}
            />
          </label>

          <label className={styles.control}>
            <span>до</span>
            <input
              type="date"
              value={mgr.dateTo}
              onChange={(e) => mgr.setDateTo(e.target.value)}
              className={styles.input}
            />
          </label>

          <label className={styles.control}>
            <span>Дата:</span>
            <select
              value={mgr.sortDir}
              onChange={(e) => mgr.setSortDir(e.target.value)}
              className={styles.select}
            >
              <option value="desc">спадання (нові зверху)</option>
              <option value="asc">зростання (старі зверху)</option>
            </select>
          </label>

          <label className={styles.control}>
            <span>Статус вгорі:</span>
            <select
              value={mgr.statusPin}
              onChange={(e) => mgr.setStatusPin(e.target.value)}
              className={styles.select}
            >
              <option value="Усі">Усі</option>
              {mgr.STATUS_OPTIONS.map((s) => (
                <option key={s} value={s}>
                  {s}
                </option>
              ))}
            </select>
          </label>

          <label className={styles.controlCheck}>
            <input
              type="checkbox"
              checked={mgr.statusOnly}
              onChange={(e) => mgr.setStatusOnly(e.target.checked)}
            />
            <span>Показувати лише цей статус</span>
          </label>

          <label className={styles.control}>
            <span>На сторінці:</span>
            <select
              value={mgr.pageSize}
              onChange={(e) => mgr.setPageSize(Number(e.target.value))}
              className={styles.select}
            >
              {PAGE_SIZES.map((n) => (
                <option key={n} value={n}>
                  {n}
                </option>
              ))}
            </select>
          </label>
        </div>
      </div>

      {/* TABLE */}
      <div className={styles.tableWrap}>
        <table className={styles.table}>
          <thead>
            <tr>
              <th className={styles.colCheck}></th>
              <th>Дата створення</th>
              <th>ID</th>
              <th>Покупець</th>
              <th>Статус</th>
              <th>Оплата</th>
              <th>Рахунок</th>
              <th>Оплачено</th>
              <th>Скасовано</th>
              <th className={styles.colSum}>Сума</th>
              <th>Позиції</th>
            </tr>
          </thead>

          <tbody>
            {mgr.paged.map((row) => {
              const id = row.order.id;
              const isOpen = !!mgr.expanded[id];

              return (
                <OrderRow
                  key={id}
                  styles={styles}
                  row={row}
                  isOpen={isOpen}
                  toggleExpand={mgr.toggleExpand}
                  editingStatusId={mgr.editingStatusId}
                  statusDraft={mgr.statusDraft}
                  setStatusDraft={mgr.setStatusDraft}
                  beginEditStatus={mgr.beginEditStatus}
                  saveStatus={mgr.saveStatus}
                  onStatusKey={mgr.onStatusKey}
                  statusOptions={mgr.STATUS_OPTIONS}
                  editingTtnId={mgr.editingTtnId}
                  ttnDraft={mgr.ttnDraft}
                  setTtnDraft={mgr.setTtnDraft}
                  beginEditTTN={mgr.beginEditTTN}
                  saveTTN={mgr.saveTTN}
                  saveTTNAndSetStatus={mgr.saveTTNAndSetStatus}
                  cancelEditTTN={mgr.cancelEditTTN}
                  onTtnKey={mgr.onTtnKey}
                  editingItemsId={mgr.editingItemsId}
                  itemsDraft={mgr.itemsDraft}
                  newPid={mgr.newPid}
                  setNewPid={mgr.setNewPid}
                  newQty={mgr.newQty}
                  setNewQty={mgr.setNewQty}
                  savingItems={mgr.savingItems}
                  beginEditItems={mgr.beginEditItems}
                  cancelEditItems={mgr.cancelEditItems}
                  setItemQty={mgr.setItemQty}
                  removeDraftItem={mgr.removeDraftItem}
                  addDraftItem={mgr.addDraftItem}
                  saveItems={mgr.saveItems}
                />
              );
            })}

            {mgr.paged.length === 0 && (
              <tr>
                <td colSpan={11} style={{ padding: 16, textAlign: "center" }}>
                  Замовлень не знайдено
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* PAGINATION (в цьому файлі, без окремого компоненту) */}
      <div className={styles.paginator}>
        <button
          className={styles.pageBtn}
          onClick={() => mgr.goto(1)}
          disabled={mgr.pageClamped === 1}
        >
          « Перша
        </button>

        <button
          className={styles.pageBtn}
          onClick={() => mgr.goto(mgr.pageClamped - 1)}
          disabled={mgr.pageClamped === 1}
        >
          ‹ Назад
        </button>

        <span className={styles.pageInfo}>
          Сторінка {mgr.pageClamped} з {mgr.totalPages}
        </span>

        <button
          className={styles.pageBtn}
          onClick={() => mgr.goto(mgr.pageClamped + 1)}
          disabled={mgr.pageClamped === mgr.totalPages}
        >
          Вперед ›
        </button>

        <button
          className={styles.pageBtn}
          onClick={() => mgr.goto(mgr.totalPages)}
          disabled={mgr.pageClamped === mgr.totalPages}
        >
          Остання »
        </button>
      </div>
    </div>
  );
}
